
export default function filterCourses() {
    const form = document.querySelector("#coursesearch");
    if (form) {

      const body = document.querySelector("body");
      const courses = document.querySelectorAll(".Card-link-container")
      const publicationsWrapper = document.querySelector('.Publications')
      const publications = document.querySelectorAll(".Publication-link");
      const publicationsPretitle = document.querySelector(".Publications-headline")
      const coursesContainer = document.querySelectorAll('.Courses-container');
      const allRoles = JSON.parse(window.BF_ROLES);
  
      let currentPage = 1;
     
      form.innerHTML += `<select class="Courses-form-select Courses-form-select--end" name="role" id="roll"><option value="" disabled selected>Välj roll</option>

      </select>`;


      form.addEventListener("change", (e) => {
        e.preventDefault();
        let currentRoleID
        let currentChildID


        const childCheck = (item, dataset) => {
          currentRoleID = parseInt(document.getElementById("verksamhet").value);
          currentChildID = parseInt(document.getElementById("roll").value);
          
          const matched = JSON.parse(dataset).filter(i => i.parent === currentRoleID && i.taxID === currentChildID) 
          !matched.length ? item.classList.add("is-hidden") : item.classList.remove("is-hidden");

        }
  
        const roleCheck = (item, dataset) => {
          const matched = JSON.parse(dataset).filter(i => i.parent === currentRoleID)
          !matched.length ? item.classList.add("is-hidden") : item.classList.remove("is-hidden");

          if (document.getElementById("verksamhet").value === 'alla') {
            item.classList.remove("is-hidden");
          } 
        }

     
        

        if (e.target.id === 'verksamhet') {
       
        currentRoleID = parseInt(document.getElementById("verksamhet").value);
        const childrenOptions = document.getElementById("roll");
        const currentRoleChildren = allRoles.filter(role => role.parent === currentRoleID)
        let selectContent = '';
        childrenOptions.innerHTML = `<option value="" selected disabled>Välj roll</option>`


        currentRoleChildren.forEach(rc => {
          selectContent += `<option value=${rc.term_id}>${rc.name}</option>`
        })

        childrenOptions.innerHTML += selectContent; 

        courses.forEach(c => {
            roleCheck(c, c.dataset.card)
          }
        )

        publications.forEach(p => {
          roleCheck(p, p.dataset.publication)
        })
      }

      if (e.target.id === 'roll') {
          courses.forEach(c => {
            childCheck(c, c.dataset.card)
          }
        )
        publications.forEach(p => {
           childCheck(p, p.dataset.publication)
        })
      }        


      // TODO: do this better... 
      coursesContainer.forEach(c => {
        if (c.children.length === c.querySelectorAll('.is-hidden').length) {
          c.previousSibling.previousSibling.classList.add('is-hidden')
          c.classList.add('is-hidden')
        } else {
          c.previousSibling.previousSibling.classList.remove('is-hidden')
          c.classList.remove('is-hidden')

        }
       });



      if (publications.length === [...publications].filter(p => p.className.includes('is-hidden')).length) { 
      
      publicationsWrapper.classList.add('is-hidden')
      publicationsPretitle.classList.add('is-hidden') 
      } else {
      publicationsWrapper.classList.remove('is-hidden')
      publicationsPretitle.classList.remove('is-hidden')
      }
    });

  }
}